<template>
  <div id="footer"
       class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/白色logo.png"
           alt="logo图">
    </div>
    <p class="title">酒水外卖，师兄好快</p>
    <p class="email_wx">
      <span>电话：18082785656</span>
      <span>邮箱：390766819@qq.com</span>
    </p>
    <p class="address_tel_fax">
      <span>地址：云南省昆明市西山区凯旋花园北区n9栋一单元101</span>
    </p>

    <p class="copy">Copyright &copy; 2022 - {{ new Date().getFullYear() }} 云南酒师兄网络科技有限公司</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data () {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo img {
  width: 101px;
  height: 45px;
  margin: 50px auto 17px auto;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue